import { getCoreApi } from '@/utility/getCoreApi';

import apiRequest from './apiRequest';

interface IFlag {
  reason: string;
}

export const flagListing = async (listingId: number, reason: string): Promise<IFlag> => {
  const url = `${getCoreApi()}/rentals/${listingId}/flag`;
  const message = await apiRequest<IFlag>({ url, method: 'POST', data: { reason } }, true);
  return message;
};
